import { MDBCol, MDBRow } from 'mdb-react-ui-kit'
import React, { useEffect, useState } from 'react'
import '../../Pages/Css/solicitudes.css';
import TooltipComponent from '../../componentes/radix/Tooltip';
import Swal from 'sweetalert2';
import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';
import axios from '../../utils/axiosConfig';
import EnviarReporteContratoButton from '../EnviarReporteContratoButton';
import SwitchButton from '../../componentes/SwitchButton';
import { formattedGlobalDate } from '../../utils/formattedDates';
import {
    preferredLocalToUTCDateTime,
    utcToPreferredLocalDateTime,
} from '../../utils/timezoneDateConversion';

const FormReporteServicio = ({
    contrato,
    images,
    tracking,
    consolidado,
    bitInsert = true,
    bitEdit = true,
}) => {
    const [fHora, setFHora] = useState('');
    const [fHoraFormatted, setFHoraFormated] = useState(null);
    const [notas, setNotas] = useState(null);
    const [ubicacion, setUbicacion] = useState(null);
    const [listReportes, setListReportes] = useState([]);
    const [listTiposEstados, setListTiposEstados] = useState([]);
    const [tipoReportes, setTipoReportes] = useState([]);
    const [idReport, setIdReport] = useState(null);
    const [selectedTipyStatus, setSelectedTipyStatus] = useState(null);
    const [selectedTipyAction, setSelectedTipyAction] = useState(null);
    const [asegurado, setAsegurado] = useState("");
    const [individual, setIndividual] = useState(false);
    const [openActionMenuId, setOpenActionMenuId] = useState(null);
    const userSolicitud = localStorage.getItem('username');

    const idSolicitud = contrato;
    //METHOD SORT
    const [sortBy, setSortBy] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc');

    const monitoreoCellStyle = {
        color: "#000",
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        verticalAlign: "top",
        lineHeight: 1.35,
        padding: "10px 8px",
    };

    const monitoreoHeaderStyle = {
        color: "#ffffff",
        textAlign: 'center',
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        verticalAlign: "middle",
        padding: "10px 8px",
    };

    const monitoreoActionCellStyle = {
        ...monitoreoCellStyle,
        textAlign: "center",
        minWidth: "40px",
        whiteSpace: "nowrap",
        padding: "6px 2px",
    };



    const handleCheckboxChangeIndividual = (newValue) => {
        setIndividual(newValue);
        // console.log(newValue);
    };

    useEffect(() => {
        const handleOutsideActionMenu = (event) => {
            if (!event.target.closest('.monitoreo-action-menu')) {
                setOpenActionMenuId(null);
            }
        };

        document.addEventListener('mousedown', handleOutsideActionMenu);

        return () => {
            document.removeEventListener('mousedown', handleOutsideActionMenu);
        };
    }, []);

    //FORMATEO FECHA Y HORA
    const handleDateTimeChangeHoraCita = (e) => {
        const value = e.target.value;
        setFHora(value);

        const utcValue = preferredLocalToUTCDateTime(value, {
            separator: ' ',
            withSeconds: true,
        });
        setFHoraFormated(utcValue || null);
    };

    const formattedSetTime = (time) => {
        const localValue = utcToPreferredLocalDateTime(time, {
            separator: 'T',
            withSeconds: false,
        });
        setFHora(localValue || '');
        const utcValue = preferredLocalToUTCDateTime(localValue, {
            separator: ' ',
            withSeconds: true,
        });
        setFHoraFormated(utcValue || null);
    };

    const handleSelectChangeTipoAccion = (event) => {
        const selectState = parseInt(event.target.value);
        setSelectedTipyAction(selectState);
        // console.log("Tipo accion selescted: ", selectState);
    }
    const handleSelectChangeTipoStatus = (event) => {
        const selectState = parseInt(event.target.value);
        setSelectedTipyStatus(selectState);
        // console.log("Tipo estado selescted: ", selectState);
    }

    //LISTAR SOLISICITUDES REPORTES
    const listarReporteServicios = () => {
        let dataContrato = {
            contrato: idSolicitud
        }
        axios
            .post(process.env.REACT_APP_SERVER + "/contratos/getreportestrafico", JSON.stringify(dataContrato), {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                },
                withCredentials: true,
            })
            .then((res) => {
                if (res.data.success == false) {
                    window.location = "/";
                } else {
                    // console.log("Informacion REPORTE SEGU8IMINETO SERVICIO: ", res.data.data);
                    setListReportes(res.data.data);
                }
            }).catch((err) => console.error(err));
    }

    //LISTAR EESTADOS
    const listTipoAccionesReportes = () => {

        axios
            .get(process.env.REACT_APP_SERVER + "/contratos/gettipoacciones", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                },
                withCredentials: true,
            })
            .then((res) => {
                if (res.data.success == false) {
                    window.location = "/";
                } else {
                    // console.log("Informacion REPORTE SEGU8IMINETO accion realizada: ", res.data.data);
                    setTipoReportes(res.data.data);
                }
            }).catch((err) => console.error(err));
    }
    const listTipoEstadoReporte = () => {

        axios
            .get(process.env.REACT_APP_SERVER + "/contratos/gettiporeportes", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                },
                withCredentials: true,
            })
            .then((res) => {
                if (res.data.success == false) {
                    window.location = "/";
                } else {
                    // console.log("Informacion REPORTE SEGU8IMINETO estados servicio: ", res.data.data);
                    setListTiposEstados(res.data.data);
                }
            }).catch((err) => console.error(err));
    }

    //CARGAR INFO
    const loadFillData = (array) => {
        // console.log("este es el array de la funcion loadFillData", array);
        return array.map((data, index) => {
            // console.log("Data XTIME: ", data.XTime);
            // Función para formatear la fecha y hora
            const formatDate = (dateTimeString) => {
                // Parsea el string ISO 8601 a objeto Date
                const parsedDate = parseISO(dateTimeString);

                // Formatea la fecha y hora según el formato deseado
                const formattedDate = format(parsedDate, "d MMMM yyyy h:mma", { locale: es });

                return formattedDate;
            };

            const formattedSetTime = (time) => {
                // Divide la cadena en fecha y hora
                const [date, timePart] = time.split('T');

                // Asegúrate de que la parte de la hora no contenga la parte '.000Z'
                const cleanTimePart = timePart.split('.')[0];

                // Combina la fecha y la hora formateada
                const formattedDateTime = `${date} ${cleanTimePart}`;

                // console.log("Datos fecha formateado para actualizar ***", formattedDateTime);

                // Aquí puedes actualizar tu estado o realizar alguna acción con formattedDateTime
                return formattedDateTime;
            };

            const formateo = formattedGlobalDate(data.XTime);


            // const formatedTimeZone = formattedSetTime(data.XTime);

            // Ejemplo de uso con la cadena formateada previamente
            // const formattedDate = formatDate(formatedTimeZone); // Usar aquí tu cadena formateada anteriormente

            const openMenuDownward = index < 2;

            return (
                <React.Fragment >
                    {/* <tr onClick={() => this.toggleRow(data.ContractID)}> */}

                    <tr>

                        <td style={{ ...monitoreoCellStyle, height: '10px' }}>{formateo}</td>


                        <td style={monitoreoCellStyle}>{data.TipoAccion}</td>


                        <td style={monitoreoCellStyle}>{data.TipoReporte}</td>


                        <td style={monitoreoCellStyle}>{data.Ubicacion}</td>


                        <td style={monitoreoCellStyle}>{data.Nota}</td>


                        <td style={monitoreoCellStyle}>{data.XUser}</td>


                        <td style={monitoreoActionCellStyle}>
                            <div
                                className="monitoreo-action-menu"
                                style={{ position: "relative", display: "inline-flex", justifyContent: "center" }}
                                onBlur={(event) => {
                                    if (!event.currentTarget.contains(event.relatedTarget)) {
                                        setOpenActionMenuId(null);
                                    }
                                }}
                            >
                                <button
                                    className="btn p-0 dropdown-toggle hide-arrow"
                                    type="button"
                                    aria-expanded={openActionMenuId === data.IdReport}
                                    aria-haspopup="menu"
                                    onClick={() =>
                                        setOpenActionMenuId((prev) => (prev === data.IdReport ? null : data.IdReport))
                                    }
                                    style={{
                                        border: "none",
                                        background: "transparent",
                                        color: "#006699",
                                        padding: "0",
                                        lineHeight: 1,
                                        minWidth: "24px",
                                        minHeight: "24px",
                                    }}
                                >
                                    <i className="bx bx-dots-vertical position-static" style={{ fontSize: "20px" }}></i>
                                </button>
                                {openActionMenuId === data.IdReport && (
                                    <div
                                        className="dropdown-menu show"
                                        style={{
                                            position: "absolute",
                                            right: 0,
                                            ...(openMenuDownward
                                                ? { top: "calc(100% + 6px)" }
                                                : { bottom: "calc(100% + 6px)" }),
                                            zIndex: 30,
                                            display: "block",
                                        }}
                                    >
                                        <button
                                            type="button"
                                            className="dropdown-item"
                                            onClick={() => {
                                                setOpenActionMenuId(null);
                                                loadDataUpdate(data.IdReport);
                                            }}
                                        >
                                            Editar
                                        </button>
                                        <button
                                            type="button"
                                            className="dropdown-item text-danger"
                                            onClick={() => {
                                                setOpenActionMenuId(null);
                                                deleteReporteSeguimiento(data.IdReport);
                                            }}
                                        >
                                            Eliminar
                                        </button>
                                    </div>
                                )}
                            </div>
                        </td>


                    </tr>

                </React.Fragment >
            )
        })
    }

    //CARGAR TIOPO DE ASEGURADO BOOLEAN
    const handleChangeAsegurado = () => {
        let dataReporte = {
            FKICTipoReporte: selectedTipyStatus
        }
        axios
            .post(process.env.REACT_APP_SERVER + "/contratos/getaseguradotiporeporte", JSON.stringify(dataReporte), {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                },
                withCredentials: true,
            })
            .then((res) => {
                if (res.data.success == false) {
                    window.location = "/";
                } else {
                    // console.log("Informacion REPORTE SEGU8IMINETO SERVICIO asegurado: ", res.data.data);
                    setAsegurado(res.data.data[0].Asegurar);
                }
            }).catch((err) => console.error(err));
    }

    //CARGAR INFO PARA ACTUALIZAR
    const loadDataUpdate = (idReport) => {
        // console.log("ID Reporte: ", idReport);
        const filteredByIdReport = listReportes.filter((report) => report.IdReport === idReport);
        // console.log(filteredByIdReport);
        const filteredByIdReportState = listTiposEstados.filter((reportstate) => reportstate.TipoReporte === filteredByIdReport[0].TipoReporte);
        const filteredByIdReportAction = tipoReportes.filter((actiontstate) => actiontstate.TipoAccion === filteredByIdReport[0].TipoAccion);
        // console.log("este es el array de la funcion loadDataUpdate cambio de estado : ", filteredByIdReportState);
        formattedSetTime(filteredByIdReport[0].XTime);
        setNotas(filteredByIdReport[0].Nota);
        setSelectedTipyStatus(filteredByIdReportState[0].IdTipoReporte);
        setSelectedTipyAction(filteredByIdReportAction[0].IdTipoAccion);
        setUbicacion(filteredByIdReport[0].Ubicacion);
        setIdReport(filteredByIdReport[0].IdReport);
        setIndividual();
    }

    //INSERTAR REPORTE DE SEGUIMIENTO
    const insertReporteSeguimiento = () => {
        const xTimeUtc = preferredLocalToUTCDateTime(fHora, {
            separator: ' ',
            withSeconds: true,
        }) || fHoraFormatted;

        let dataReport = {
            FKICTipoReporte: selectedTipyStatus,
            FKLokTipoAccion: selectedTipyAction,
            Nota: notas,
            Ubicacion: ubicacion,
            XTime: xTimeUtc,
            Individual: individual,
            FKLokContractID: idSolicitud
        }
        // console.log("Data sreporte solcicitud antes de subirlo : ", dataReport);
        if (!fHora || !notas || !ubicacion || !selectedTipyStatus || !selectedTipyAction || selectedTipyAction === tipoReportes[0].IdTipoAccion || selectedTipyStatus === listTiposEstados[0].IdTipoReporte) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Debe llenar los campos obligatorios",
                didOpen: () => {
                    const confirmButton = Swal.getConfirmButton();
                    confirmButton.style.backgroundColor = '#ff0000';
                    confirmButton.style.color = '#ffffff';
                    confirmButton.style.border = 'none';
                    confirmButton.style.padding = '10px 20px';
                    confirmButton.style.fontSize = '16px';
                    confirmButton.style.borderRadius = '5px';
                    confirmButton.style.cursor = 'pointer';
                }
            });
        } else {
            axios
                .post(process.env.REACT_APP_SERVER + "/contratos/insertreportetrafico", JSON.stringify(dataReport), {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                    },
                    withCredentials: true,
                })
                .then((res) => {
                    if (res.data.success == false) {
                        window.location = "/";
                    } else {
                        // console.log("Informacion REPORTE SEGU8IMINETO INSERTARRR *****: ", res.data.data);
                        listarReporteServicios();
                        clearFields();
                    }
                }).catch((err) => console.error(err));
        }
    }

    //ACTUALIZAR REPORTE DE SEGUIMIENTO
    const updateReporteSeguimiento = () => {
        const xTimeUtc = preferredLocalToUTCDateTime(fHora, {
            separator: ' ',
            withSeconds: true,
        }) || fHoraFormatted;

        let dataReportUPT = {
            FKICTipoReporte: selectedTipyStatus,
            FKLokTipoAccion: selectedTipyAction,
            Nota: notas,
            Ubicacion: ubicacion,
            XTime: xTimeUtc,
            IdReport: idReport,
        }
        if (!fHora || !notas || !ubicacion || !selectedTipyStatus || !selectedTipyAction || selectedTipyAction === tipoReportes[0].IdTipoAccion || selectedTipyStatus === listTiposEstados[0].IdTipoReporte) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Debe llenar todos los campos.",
                didOpen: () => {
                    const confirmButton = Swal.getConfirmButton();
                    confirmButton.style.backgroundColor = '#ff0000';
                    confirmButton.style.color = '#ffffff';
                    confirmButton.style.border = 'none';
                    confirmButton.style.padding = '10px 20px';
                    confirmButton.style.fontSize = '16px';
                    confirmButton.style.borderRadius = '5px';
                    confirmButton.style.cursor = 'pointer';
                }
            });
        } else {
            axios
                .post(process.env.REACT_APP_SERVER + "/contratos/updatereportetrafico", JSON.stringify(dataReportUPT), {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                    },
                    withCredentials: true,
                })
                .then((res) => {
                    if (res.data.success == false) {
                        window.location = "/";
                    } else {
                        // console.log("Informacion REPORTE SEGU8IMINETO ACTUALIZAR *****: ", res.data.data);
                        listarReporteServicios();
                        clearFields();
                    }
                }).catch((err) => console.error(err));
        }
    }

    //ELIMINAR REPORTE DE SEGUIMIENTO
    const deleteReporteSeguimiento = (IdReport) => {
        // console.log("Id reporte: ", IdReport);
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'custom-confirm-button', // or 'btn btn-info' if you use Bootstrap
                cancelButton: 'custom-cancel-button' // or 'btn btn-danger' if you use Bootstrap
            },
            buttonsStyling: false
        });
        swalWithBootstrapButtons.fire({
            title: "Está seguro?",
            text: "Esto no es reversible!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Si, anular",
            cancelButtonText: "No, cancelar!",
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                let dataReporteAnular = {
                    IdReport: IdReport
                }
                axios
                    .post(process.env.REACT_APP_SERVER + "/contratos/deletereportetrafico", JSON.stringify(dataReporteAnular), {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                        },
                        withCredentials: true,
                    })
                    .then((res) => {
                        if (res.data.success == false) {
                            window.location = "/";
                        } else {
                            listarReporteServicios();
                            swalWithBootstrapButtons.fire({
                                title: "Eliminado!",
                                text: "Su reporte de seguimiento ha sido anulada con éxito.",
                                icon: "success"
                            });

                        }
                    }).catch((err) => console.error(err));


            } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
            ) {
                console.error("no se anuilo la solicitud");
            }
        });


    }



    //LIMPIAR CAMPOS
    const clearFields = () => {
        cargarFechaHoraActual();
        setNotas("");
        setIndividual(false);
        setSelectedTipyAction(tipoReportes[0].IdTipoAccion);
        setSelectedTipyStatus(listTiposEstados[0].IdTipoReporte);
        setIdReport(null);
        setAsegurado("");
        setUbicacion("");
    }

    //CARGAR FECHA HORA ACTUAL APENAS SE CARGA EL COMPONENTE
    const cargarFechaHoraActual = () => {
        const localNow = utcToPreferredLocalDateTime(new Date().toISOString(), {
            separator: 'T',
            withSeconds: false,
        });
        const utcNow = preferredLocalToUTCDateTime(localNow, {
            separator: ' ',
            withSeconds: true,
        });
        setFHora(localNow || '');
        setFHoraFormated(utcNow || null);
    };

    const imagesModal = (e) => {
        e.preventDefault();
        // console.log("Abrir modal de imagenes");
        images();

    }

    const trackingModal = (e) => {
        e.preventDefault();
        // console.log("Abrir modal de tracking");
        tracking();
    }

    const consolidadoModal = (e) => {
        e.preventDefault();
        // console.log("Abrir modal de consolidado");
        consolidado();
    }


    const renderSortIcon = (column) => {

        if (sortBy === column) {
            if (sortDirection === "asc") {
                return <span>&uarr;</span>; // Icono de flecha hacia arriba
            } else {
                return <span>&darr;</span>; // Icono de flecha hacia abajo
            }
        }

        return null; // No mostrar ningún ícono si no está ordenado por esta columna
    }

    // const tiposEstados = [
    //     { id: 1, nombre: 'Pendiente' },
    //     { id: 2, nombre: 'En proceso' },
    //     { id: 3, nombre: 'Finalizado' },

    // ];

    useEffect(() => {
        listarReporteServicios();
        listTipoAccionesReportes();
        listTipoEstadoReporte();
        cargarFechaHoraActual();
    }, []);

    useEffect(() => {
        if (selectedTipyStatus) {
            handleChangeAsegurado();
        }
    }, [selectedTipyStatus]);

    useEffect(()=>{
        console.log("monitoreo trafico");
        console.log("Contrato: ", contrato);
    },[contrato]);



    // <i class='bx bxs-pencil bx-tada' style={{ color: '#006699' }}></i>
    return (
        <div style={{ height: '75vh' }} className='containerMonitoreoTrafico monitoreo-modern'>
            <MDBRow style={{ marginTop: '-15px', marginBottom: '10px' }} className='monitoreo-links-row'>
                <div style={{ display: 'flex', flexDirection: 'row' }} className='monitoreo-links'>
                    <a href="#" onClick={(e) => { imagesModal(e) }}>Imagenes IA</a>&nbsp;/&nbsp;<a href="#" onClick={(e) => { trackingModal(e) }}>Tracking</a>&nbsp;/&nbsp;<a href="#" onClick={(e) => { consolidadoModal(e) }}>Consolidado</a>
                </div>
            </MDBRow>
            <MDBRow style={{ display: 'flex', alignItems: 'start', justifyContent: 'start', flexDirection: 'column' }} className='monitoreo-form-card'>
                {/* Número de solicitud */}
                <MDBCol md={6} style={{ display: 'flex', flexDirection: 'row' }} className='columnsStyles'>
                    <MDBCol md={5}>
                        <div className="InputTooltipWrapper reporteSeolicitud">
                            <label className="Label" htmlFor="solicitud">Contrato</label>
                            {/* <TooltipComponent message={'Acá iría el número que identifica la solicitud en curso '} /> */}
                        </div>
                    </MDBCol>
                    <MDBCol md={8} className='reporteSeolicitudInputt'>
                        <input className="Input" id="name" defaultValue={idSolicitud} disabled />
                    </MDBCol>
                </MDBCol>

                {/* Fecha y hora */}
                <MDBCol md={6} style={{ display: 'flex', flexDirection: 'row' }} className='columnsStyles'>
                    <MDBCol md={5}>
                        <div className='InputTooltipWrapper reporteSeolicitud'>
                            <label className="Label" htmlFor="fechaHoraCita">Fecha/Hora</label>
                            {/* <TooltipComponent message={'Escoge una fecha y hora para tu solicitud'} /> */}
                        </div>
                    </MDBCol>
                    <MDBCol md={8} className='reporteSeolicitudInputt'>
                        <input className="Input" id="fechaHoraCita" type='datetime-local' value={fHora} onChange={handleDateTimeChangeHoraCita} />
                    </MDBCol>
                </MDBCol>

                {/* Ubicacion */}
                <MDBCol md={6} style={{ display: 'flex', flexDirection: 'row' }} className='columnsStyles'>
                    <MDBCol md={5}>
                        <div className='InputTooltipWrapper reporteSeolicitud'>
                            <label className="Label" htmlFor="fechaHoraCita">Ubicacion</label>
                            <span style={{ color: 'red', fontSize: 15 }}>*</span>
                            {/* <TooltipComponent message={'Escoge una fecha y hora para tu solicitud'} /> */}
                        </div>
                    </MDBCol>
                    <MDBCol md={8} className='reporteSeolicitudInputt'>
                        <input className="Input" id="fechaHoraCita" type='text' placeholder='Ubicación del vehículo' value={ubicacion} onChange={(e) => setUbicacion(e.target.value)} />
                    </MDBCol>
                </MDBCol>

                {/* Accion Realizada */}
                <MDBCol md={6} style={{ display: 'flex', flexDirection: 'row' }} className='columnsStyles'>
                    <MDBCol md={5}>
                        <div className="InputTooltipWrapper reporteSeolicitud">
                            <label className="Label" htmlFor="tipoContrato">Acción Realizada</label>
                            <span style={{ color: 'red', fontSize: 15 }}>*</span>
                            {/* <span style={{ color: 'red', fontSize: 15 }}>*</span> */}
                            {/* <TooltipComponent message={'Selecciona el estado de la solicitud'} /> */}
                        </div>
                    </MDBCol>
                    <MDBCol md={12} className='reporteSeolicitudInputt'>
                        <select className="InputSelectReportSeguimihnetoSol" onChange={handleSelectChangeTipoAccion} value={selectedTipyAction}>
                            {tipoReportes.map((tipo) => (
                                <option key={tipo.IdTipoAccion} value={tipo.IdTipoAccion}>
                                    {tipo.TipoAccion}
                                </option>
                            ))}
                        </select>
                    </MDBCol>
                </MDBCol>

                {/* Estado de solicitud */}
                <MDBCol md={6} style={{ display: 'flex', flexDirection: 'row' }} className='columnsStyles'>
                    <MDBCol md={5}>
                        <div className="InputTooltipWrapper reporteSeolicitud">
                            <label className="Label" htmlFor="tipoContrato">Estado de servicio</label>
                            <span style={{ color: 'red', fontSize: 15 }}>*</span>
                            {/* <span style={{ color: 'red', fontSize: 15 }}>*</span> */}
                            {/* <TooltipComponent message={'Selecciona el estado de la solicitud'} /> */}
                        </div>
                    </MDBCol>
                    <MDBCol md={12} className='reporteSeolicitudInputt'>
                        <select className="InputSelectReportSeguimihnetoSol" onChange={handleSelectChangeTipoStatus} value={selectedTipyStatus}>
                            {listTiposEstados.map((state) => (
                                <option key={state.IdTipoReporte} value={state.IdTipoReporte}>
                                    {state.TipoReporte}
                                </option>
                            ))}
                        </select>
                    </MDBCol>
                </MDBCol>


                {/* Notas */}
                <MDBCol md={10} style={{ display: 'flex', flexDirection: 'row' }} className='columnsStyles'>
                    <MDBCol md={3}>
                        <div className='contToltip reporteSeolicitud'>
                            <label className="Label" htmlFor="observacionesServicio">Notas</label>
                            <span style={{ color: 'red', fontSize: 15 }}>*</span>
                            {/* <TooltipComponent message={'Cliente para consultas'} /> */}
                        </div>
                    </MDBCol>
                    <MDBCol md={10} className='reporteMonitoreoInputt'>
                        <textarea className="TextAreaReportSe" value={notas} onChange={(e) => setNotas(e.target.value)} />
                    </MDBCol>
                </MDBCol>
                <br />

                {/* SwitchButtons */}
                <MDBCol md={6} style={{ display: 'flex', flexDirection: 'row' }} className='columnsStyles'>
                    <MDBCol md={5}>
                        <div className='contToltip reporteSeolicitud'>
                            <label className="Label" htmlFor="observacionesServicio">Asegurado</label>
                            {/* <TooltipComponent message={'Cliente para consultas'} /> */}
                        </div>
                    </MDBCol>
                    <MDBCol md={12} className='reporteSeolicitudInputt'>
                        {!asegurado ? ' desactivado' : ' activado'}

                    </MDBCol>
                </MDBCol>
                <MDBCol md={6} style={{ display: 'flex', flexDirection: 'row' }} className='columnsStyles'>
                    <MDBCol md={5}>
                        <div className='contToltip reporteSeolicitud'>
                            <label className="Label" htmlFor="observacionesServicio">Individual</label>
                            {/* <TooltipComponent message={'Cliente para consultas'} /> */}
                        </div>
                    </MDBCol>
                    <MDBCol md={12} className='reporteSeolicitudInputt'>
                        <SwitchButton checked={individual} onChange={handleCheckboxChangeIndividual} type={'\u00A0'} />
                    </MDBCol>
                    <div className="ButtonWrapper monitoreo-button-wrap" style={{ display: 'flex', justifyContent: 'flex-start', gap: '12px', transform: "translate(-70px,-25px)" }}>


                        {idReport ? (
                            <button
                                className="Button blue monitoreo-primary-btn"
                                disabled={!bitEdit}
                                onClick={(e) => { e.preventDefault(); updateReporteSeguimiento(); }}
                            >Actualizar</button>

                        ) : (
                            <button
                                className="Button blue monitoreo-primary-btn"
                                disabled={!bitInsert}
                                onClick={(e) => { e.preventDefault(); insertReporteSeguimiento(); }}
                            // data-bs-dismiss='modal'
                            >Grabar</button>

                        )}

                        <EnviarReporteContratoButton
                            contractId={idSolicitud}
                            className="Button blue monitoreo-primary-btn"
                        />
                    </div>
                </MDBCol>
            </MDBRow >



            <MDBRow>
                <MDBCol md={12}>
                    <div className="card ContainerTableReportesSolicitudes monitoreo-table-card" >
                        <div
                            className="table-responsive monitoreo-table-responsive"
                            style={{
                                maxHeight: "320px",
                                minHeight: "220px",
                                overflowY: "scroll",
                                overflowX: "hidden",
                                display: "block",

                                // flexDirection: "column",
                            }}
                        >
                            <table className="table table-hover monitoreo-table-inner" id="tabla" style={{ width: "100%", tableLayout: "fixed" }}>
                                <thead className="FondoHeaderTabla2">
                                    <tr>

                                        <th
                                            style={{ ...monitoreoHeaderStyle, width: '14%' }}
                                        // onClick={() => sortData("IDSolicitudes")}
                                        >
                                            Fecha/Hora {renderSortIcon("IDSolicitudes")}
                                        </th>

                                        <th
                                            style={{ ...monitoreoHeaderStyle, width: '23%' }}
                                        // onClick={() => sortData("NombreEmpresa")}
                                        >
                                            Acción{" "}
                                            {renderSortIcon("NombreEmpresa")}
                                        </th>
                                        <th
                                            style={{ ...monitoreoHeaderStyle, width: '13%' }}
                                        // onClick={() => sortData("NombreEmpresa")}
                                        >
                                            Estado{" "}
                                            {renderSortIcon("NombreEmpresa")}
                                        </th>
                                        <th
                                            style={{ ...monitoreoHeaderStyle, width: '14%' }}
                                        // onClick={() => sortData("NombreEmpresa")}
                                        >
                                            Ubicación{" "}
                                            {renderSortIcon("NombreEmpresa")}
                                        </th>

                                        <th
                                            style={{ ...monitoreoHeaderStyle, width: '24%' }}
                                        // onClick={() => sortData("Ruta")}
                                        >
                                            Observaciones {renderSortIcon("Ruta")}
                                        </th>

                                        <th
                                            style={{ ...monitoreoHeaderStyle, width: '8%' }}
                                        // onClick={() => sortData("PlacaTruck")}
                                        >
                                            Usuario {renderSortIcon("PlacaTruck")}
                                        </th>
                                        <th
                                            style={{ ...monitoreoHeaderStyle, width: '3%', minWidth: '40px' }}
                                        >
                                            
                                        </th>


                                    </tr>
                                </thead>
                                <tbody className="table-border-bottom-0" id="tabladata">
                                    {loadFillData(listReportes)}
                                    {/* el body */}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </MDBCol>
            </MDBRow>
        </div>
    )
}

export default FormReporteServicio
